import React from "react";
import "./Overlay.css";
import useScrollbarSize from "react-scrollbar-size";

export default function Overlay(props) {
  const overlayClass = props.show ? "overlay overlay-show" : "overlay";
  const { width } = useScrollbarSize();

  if (props.show) {
    document.body.classList.add("noscroll");
    if (props.adjustMargin) {
      document.body.style.marginRight = `${width}px`;
    }
  } else {
    document.body.classList.remove("noscroll");
    document.body.style.marginRight = "";
  }

  return <div className={overlayClass}>{props.children}</div>;
}
